export default __webpack_public_path__ + "static/media/attendance-orange.54fe7d1e.svg";